import { Button, HStack, Menu, MenuButton, MenuList } from "@chakra-ui/react";
import { DataTable, MenuItemLink, NavBar } from "@components/ui-kit";
import { Pagination } from "@components/ui-kit/table/pagination";
import { Trans, t } from "@lingui/macro";
import { RequestForInvoicingStatusEnum } from "@src/__generated__/urql-graphql";
import { Icon } from "@src/components/ui-kit/Icon";
import { FiltersPanel } from "@src/utils/components/filters/components/filters-panel";
import { can } from "@src/utils/components/permissions";
import cx from "classnames";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import s from "./CardListProjects.module.css";
import { PageRequestsForInvoicingCtx } from "./PageRequestsForInvoicing";
import { TableRequestsForInvoices } from "./table/TableRequestsForInvoices";

export const CardListRequestsForInvoice = observer(
  function CardListRequestsForInvoice() {
    const store = useContext(PageRequestsForInvoicingCtx);

    return (
      <div data-testid="card-list-projects">
        <DataTable>
          <div className="h-24 flex justify-between px-6">
            <NavBar>
              <NavBar.Item
                active={!store.statusFilter.value[0]}
                onClick={() => store.statusFilter.clear()}
              >
                <Trans>All</Trans>
              </NavBar.Item>
              <NavBar.Item
                active={
                  store.statusFilter.value[0] ===
                  RequestForInvoicingStatusEnum.Submitted
                }
                onClick={() => {
                  store.statusFilter.setValue([
                    RequestForInvoicingStatusEnum.Submitted,
                  ]);
                }}
              >
                <Trans>Submitted</Trans>
              </NavBar.Item>
              <NavBar.Item
                active={
                  store.statusFilter.value[0] ===
                  RequestForInvoicingStatusEnum.Draft
                }
                onClick={() => {
                  store.statusFilter.setValue([
                    RequestForInvoicingStatusEnum.Draft,
                  ]);
                }}
              >
                <Trans>Drafts</Trans>
              </NavBar.Item>
            </NavBar>
            <HStack spacing="3">
              {can(
                "requestForInvoicing_create_all",
                "requestForInvoicing_create_own",
                "requestForInvoicing_create_team",
              ) && (
                <Menu>
                  <MenuButton
                    as={Button}
                    rightIcon={<Icon name="chevron-down" />}
                    variant="solid"
                  >
                    <Trans>Add new</Trans>
                  </MenuButton>

                  <MenuList>
                    <MenuItemLink
                      href={{
                        pathname: "/invoices/for-invoicing/create-proforma",
                      }}
                    >
                      <Trans>Proforma</Trans>
                    </MenuItemLink>
                    <MenuItemLink
                      href={{
                        pathname: "/invoices/for-invoicing/create-invoice",
                      }}
                    >
                      <Trans>Invoice</Trans>
                    </MenuItemLink>
                    <MenuItemLink
                      href={{
                        pathname: "/invoices/for-invoicing/create-credit-note",
                      }}
                    >
                      <Trans>Credit note</Trans>
                    </MenuItemLink>
                  </MenuList>
                </Menu>
              )}
            </HStack>
          </div>
          <hr />
          <div data-testid="filters" className={cx(s.filters, "p-6")}>
            <FiltersPanel
              filters={store.where}
              searchPlaceholder={t`Search by brand, project`}
              onSearch={(val) => {
                store.searchTerm = val;
                store.pagination.resetPage();
              }}
            />
          </div>

          <div data-testid="table">
            <TableRequestsForInvoices />
            <Pagination store={store.pagination} />
          </div>
        </DataTable>
      </div>
    );
  },
);
